import { RecommendationsModal } from './recommendations-modal';

export { RecommendationsModal };
